import React, { Suspense } from 'react';

import { useStateValue } from '../state';

export default ({ children }) => {
  const Modal = React.lazy(() => import('./Modal/ModalView'));
  const [{
    modal: {
      show: modalShow,
      type,
    },
  }] = useStateValue();

  return (
    <>
      <Suspense fallback={null}>
        <Modal show={modalShow} type={type} />
      </Suspense>
      <div className="page">
        {children}
      </div>
    </>
  );
};
